import React from "react";
import Logo from "../../components/Logo";

const AuthHeader = ({ title, heightGenius = "h-12", variant = "dark" }) => {
  return (
    <div className="sm:mx-auto sm:w-full sm:max-w-md">
      <Logo business="kerakoll" variant={variant} />
      {title ? (
        <h2
          className={
            "mt-6 text-center text-3xl text-black-500 " +
            (variant === "dark" ? "text-black-500" : "text-white")
          }
        >
          {title}
        </h2>
      ) : null}
      {/* <div className="mt-2 text-center text-sm text-gray-600">
        <p className="font-medium">TEMPLATE APP - CHANGE ME</p>
      </div> */}
    </div>
  );
};

export default AuthHeader;
